"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.changeEmailLessFormSubmissionSetting = exports.unsubscribeLeadSyncingEntity = exports.selectLeadSyncingEntities = exports.fetchSelectedLeadSyncingEntities = exports.fetchAvailableLeadSyncingEntities = exports.setAdAccountTracking = exports.deleteUserAuth = exports.deleteAdAccount = exports.getConnectedUsers = exports.fetchAdAccounts = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchAdAccounts = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getAdAccounts,
  initiatingActionType: _actions.AccountsActionTypes.FETCH_AD_ACCOUNTS,
  requestStatusSelector: _selectors.getFetchAdAccountsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchAdAccounts
}));
exports.fetchAdAccounts = fetchAdAccounts;
var getConnectedUsers = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getConnectedUsers,
  initiatingActionType: _actions.AccountsActionTypes.FETCH_CONNECTED_USERS,
  requestStatusSelector: _selectors.getFetchConnectedUsersRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchConnectedUsers
}));
exports.getConnectedUsers = getConnectedUsers;
var deleteAdAccount = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteAdAccount,
  initiatingActionType: _actions.AccountsActionTypes.DELETE_AD_ACCOUNT,
  requestStatusSelector: _selectors.getDeleteAdAccountRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.DeleteAdAccount
}));
exports.deleteAdAccount = deleteAdAccount;
var deleteUserAuth = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteUserAuth,
  initiatingActionType: _actions.AccountsActionTypes.DELETE_USER_AUTH,
  requestStatusSelector: _selectors.getDeleteUserAuthRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.DeleteUserAuth
}));
exports.deleteUserAuth = deleteUserAuth;
var setAdAccountTracking = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setTrackingForAdAccount,
  initiatingActionType: _actions.AccountsActionTypes.SET_AD_ACCOUNT_TRACKING,
  requestStatusSelector: _selectors.getSetAdAccountTrackingRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SetAdAccountTracking
}));
exports.setAdAccountTracking = setAdAccountTracking;
var fetchAvailableLeadSyncingEntities = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getAvailableLeadSyncingEntities,
  initiatingActionType: _actions.AccountsActionTypes.FETCH_AVAILABLE_LEAD_SYNCING_ENTITIES,
  requestStatusSelector: _selectors.getFetchAvailableLeadSyncingEntitiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchAvailableLeadSyncingEntities
}));
exports.fetchAvailableLeadSyncingEntities = fetchAvailableLeadSyncingEntities;
var fetchSelectedLeadSyncingEntities = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSelectedLeadSyncingEntities,
  initiatingActionType: _actions.AccountsActionTypes.FETCH_SELECTED_LEAD_SYNCING_ENTITIES,
  requestStatusSelector: _selectors.getFetchSelectedLeadSyncingEntitiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSelectedLeadSyncingEntities
}));
exports.fetchSelectedLeadSyncingEntities = fetchSelectedLeadSyncingEntities;
var selectLeadSyncingEntities = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.selectLeadSyncingEntities,
  initiatingActionType: _actions.AccountsActionTypes.SELECT_LEAD_SYNCING_ENTITIES,
  requestStatusSelector: _selectors.getSelectLeadSyncingEntitiesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SelectLeadSyncingEntities
}));
exports.selectLeadSyncingEntities = selectLeadSyncingEntities;
var unsubscribeLeadSyncingEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.unsubscribeLeadSyncingEntity,
  initiatingActionType: _actions.AccountsActionTypes.UNSUBSCRIBE_LEAD_SYNCING_ENTITY,
  requestStatusSelector: _selectors.getUnsubscribeLeadSyncingEntityRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UnsubscribeLeadSyncingEntity
}));
exports.unsubscribeLeadSyncingEntity = unsubscribeLeadSyncingEntity;
var changeEmailLessFormSubmissionSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.changeEmailLessFormSubmissionsSetting,
  initiatingActionType: _actions.AccountsActionTypes.CHANGE_EMAIL_LESS_FORM_SUBMISSIONS_SETTING,
  requestStatusSelector: _selectors.getChangeEmailLessFormSubmissionSettingRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.ChangeEmailLessFormSubmissionSetting
}));
exports.changeEmailLessFormSubmissionSetting = changeEmailLessFormSubmissionSetting;

var _default = (0, _reduxObservable.combineEpics)(fetchAdAccounts, getConnectedUsers, deleteUserAuth, setAdAccountTracking, fetchAvailableLeadSyncingEntities, fetchSelectedLeadSyncingEntities, selectLeadSyncingEntities, unsubscribeLeadSyncingEntity, changeEmailLessFormSubmissionSetting);

exports.default = _default;